import { api, buff } from '@/api/api.js'
import { fetchGet } from '@/api/axios_config.js'

export default {
    namespaced: true,
    state: {

        token : sessionStorage.getItem('token' + buff) ? sessionStorage.getItem('token' + buff) : '',
        userId: sessionStorage.getItem('userId' + buff) ? sessionStorage.getItem('userId' + buff) : '',
        userName: sessionStorage.getItem('userName' + buff) ? sessionStorage.getItem('userName' + buff) : '',
        roleId: sessionStorage.getItem('roleId' + buff) ? sessionStorage.getItem('roleId' + buff) : '',
    },
    
    mutations: {
        // 更新用户相关信息
        update_user(state, payload) {
            console.log(payload)

            state.token = payload.token;
            state.userId = payload.userId;
            state.userName = payload.userName;
            state.roleId     = payload.roleId;
           
            sessionStorage.setItem('token' + buff, payload.token)
            sessionStorage.setItem('userId' + buff, payload.userId)
            sessionStorage.setItem('userName' + buff, payload.userName);
            sessionStorage.setItem('roleId' + buff, payload.roleId);
        },

        clear_user(state){

            state.token = '';
            state.userId = '';
            state.userName = '';
            state.roleId = '';
           
            sessionStorage.removeItem('token' + buff)
            sessionStorage.removeItem('userId' + buff)
            sessionStorage.removeItem('userName' + buff);
            sessionStorage.removeItem('roleId' + buff);
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/userModule.js